<template>
<b-container fluid>
  <b-alert show v-model="showEditSuccess" variant="success" class="mt-1">Qty Alarm was updated successfully</b-alert>
  <b-alert show v-model="showEditFailure" variant="warning" class="mt-1">Qty Alarm failed to update, check console for details</b-alert>
  <h3>Stock Alarm Items</h3>
  <b-row class="mb-2">
    <b-col class="mt-2" cols=3>
      <b-form-checkbox v-model="onlyShowOff" @input="getData">Only show items turned OFF</b-form-checkbox>
    </b-col>
    <b-col>
      <b-form-input v-model="filter" placeholder="Type to Filter" class="mx-1" />
    </b-col>
    <b-col cols=1>
      <b-btn @click="() => filter=''" variant="danger" class="mx-1">Clear Filter</b-btn>
    </b-col>
    <b-col cols=3>
      <b-pagination align="right" :total-rows="rows" :per-page="page_size" v-model="page" class="mb-0" />
    </b-col>
  </b-row>
  <b-table
    :fields="columns" :items="items"
    :current-page="page" :per-page="page_size"
    :filter="filter" @filtered="onFilter"
    striped hover :busy="busy" @input="unbusy"
  >
    <template slot="table-busy">
      Please Wait...
    </template>
    <template slot="product_num" slot-scope="data">
      <router-link target="_blank" :to="{name: 'Qty Calculations', query: {partNum: data.item.product_num}}">{{data.item.product_num}}</router-link>
      <br />
      <router-link target="_blank" :to="{name: 'Part/Product History', query: {search: data.item.product_num}}">History</router-link>
    </template>
    <template slot="updated_to_web" slot-scope="data">
      <span v-if="data.item.updated_to_web">✅</span><span v-else>❌</span>
    </template>
    <template slot="new_qty" slot-scope="data">
      {{data.item.new_qty}}
      <div style="font-style: italic; font-size: small;"><NiceDate :value="data.item.new_time" /></div>
    </template>
    <template slot="old_qty" slot-scope="data">
      {{data.item.old_qty}}
      <div style="font-style: italic; font-size: small;"><NiceDate :value="data.item.old_time" /></div>
    </template>
    <template slot="qty_alarm" slot-scope="data">
      <span>
        <div v-if="data.item._editing">
          <b-form-input v-model="data.item.qty_alarm" />
          <b-btn @click="editAlarm(data.item)">Save</b-btn>
          <b-btn @click="() => data.item._editing = false">Cancel</b-btn>
        </div>
        <div v-else>
          {{data.item.qty_alarm}}
          <b-btn @click="() => data.item._editing = true">Edit Alarm</b-btn>
        </div>
      </span>
    </template>
  </b-table>
</b-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import NiceDate from '../utility/NiceDate';
const BASE_API = process.env.VUE_API_ROOT;

export default {
  data() {
    return {
      showEditSuccess: false,
      showEditFailure: false,
      page: 1,
      page_size: 100,
      rows: 0,
      busy: false,
      filter: '',
      columns: [
        { key: 'product_num', label: 'Product Number', sortable: true },
        { key: 'product_desc', label: 'Product Description', sortable: true },
        { key: 'updated_to_web', label: 'FishIon Update Web Qty', sortable: true },
        { key: 'new_qty', sortable: true },
        { key: 'old_qty', sortable: true },
        { key: 'qty_alarm', sortable: true },
      ],
      items: [],
      onlyShowOff: false,
    };
  },
  components: {
    NiceDate,
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.busy = true;
      let startAt = moment().format();
      if (this.onlyShowOff) {
        axios.get(`${BASE_API}/ams3-fishioninfo/turned-off/${startAt}`).then(response => {
          this.rows = response.data.length;
          response.data.forEach(item => {
            if (item.new_product) item._rowVariant = 'secondary';
            let color = this.highlightColor(item.new_qty, item.old_qty);
            item._cellVariants = {
              new_qty: color
            };
            item._editing = false;
          });
          this.items = response.data;
        }).catch(error => {
          console.error(error);
        });
      } else {
        axios.get(`${BASE_API}/ams3-fishioninfo/low-stock/${startAt}`).then(response => {
          this.rows = response.data.length;
          response.data.forEach(item => {
            if (item.new_product) item._rowVariant = 'secondary';
            let color = this.highlightColor(item.new_qty, item.old_qty);
            item._cellVariants = {
              new_qty: color
            };
            item._editing = false;
          });
          this.items = response.data;
        }).catch(error => {
          console.error(error);
        });
      }
    },
    highlightColor(newQty, oldQty) {
      if (newQty < oldQty)
        if (newQty <= 0 && oldQty > 0) return 'danger';
        else return 'warning';
      else if (newQty > oldQty)
        if (newQty > 0 && oldQty <= 0) return 'success';
        else return 'secondary';
      return '';
    },
    onFilter(items) {
      this.rows = items.length;
      this.page = 1;
    },
    editAlarm(item) {
      this.showEditSuccess = false;
      this.showEditFailure = false;

      axios({
        method: 'post',
        headers: { 'Content-Type': 'text/plain' },
        url: `${BASE_API}/ams3-fishioninfo/low-stock/${item.product_id}`,
        data: item.qty_alarm,
      }).then(response => {
        this.showEditSuccess = true;
        item._editing = false;
      }).catch(error => {
        console.error(error);
        this.showEditFailure = true;
      })
    },
    unbusy() {
      this.busy = false;
    }
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/inventory/StockAlarm.vue